import { useTranslation } from "react-i18next";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import type { EndNodeData } from "@/lib/productGraph";

interface Props {
  data: EndNodeData;
  onChange: (patch: Partial<EndNodeData>) => void;
}

export function EndEditor({ data, onChange }: Props): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      <div className="space-y-1.5">
        <Label className="text-xs">{t("enterpriseProductBuilder.nodeLabelLabel")}</Label>
        <Input
          value={data.label ?? ""}
          onChange={(e) => onChange({ label: e.target.value })}
        />
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs">{t("enterpriseProductBuilder.endReasonLabel")}</Label>
        <Textarea
          value={data.reason ?? ""}
          onChange={(e) => onChange({ reason: e.target.value })}
          rows={2}
          placeholder={t("enterpriseProductBuilder.endReasonPlaceholder")}
        />
      </div>
    </div>
  );
}
